var render = function render(_c,_vm){return _c('vx-card',{},[_c('div',{staticClass:"vx-row mb-2"},[_c('div',{staticClass:"vx-col w-full"},[_c('h3',{staticClass:"bold"},[_c('strong',[_vm._v(_vm._s(_vm.props.title))])])])]),_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full"},[_c('p',{staticClass:"black"},[_vm._v(" "+_vm._s(_vm.props.content)+" ")]),_c('br')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }